export default __webpack_public_path__ + "assets/images/FilterExtrema-4726e71358d7d68d85ef41bf413e8cb2.png";